import { JSX } from 'react';
import { Box, Typography } from '@mui/material';
import FileUploadRequiredIcon from './FileUploadRequiredIcon';

interface Props {
  options: Array<{
    id: string | number;
    label: string;
    requires_file_upload?: boolean;
  }>;
  value: string | number | null;
  onChange: (value: string | number) => void;
}

export default function ChoicesInput({
  options,
  value,
  onChange,
}: Props): JSX.Element {
  return (
    <Box display="flex" flexDirection="column" gap="10px">
      {options.map((option) => {
        const isSelected = value === option.id;
        return (
          <Box
            key={option.id}
            onClick={() => onChange(option.id)}
            data-testid={`choice-option-${option.id}`}
            sx={{
              minHeight: 56,
              display: 'flex',
              alignItems: 'center',
              gap: 1.75,
              px: 2.25,
              py: '5px',
              borderRadius: '12px',
              border: isSelected ? '2px solid' : '1px solid',
              borderColor: isSelected ? 'primary.main' : 'divider',
              bgcolor: 'background.paper',
              cursor: 'pointer',
              '&:hover': {
                borderColor: isSelected ? 'primary.main' : 'grey.400',
              },
            }}
          >
            <Box
              sx={{
                width: 20,
                height: 20,
                borderRadius: '50%',
                flexShrink: 0,
                ...(isSelected
                  ? { bgcolor: 'primary.main' }
                  : { border: '2px solid', borderColor: 'grey.300' }),
              }}
            />
            <Typography
              fontWeight={isSelected ? 600 : 'normal'}
              sx={{ flex: 1, minWidth: 0 }}
            >
              {option.label}
            </Typography>
            {option.requires_file_upload && <FileUploadRequiredIcon />}
          </Box>
        );
      })}
    </Box>
  );
}
